import slugify from 'slugify';
import orderBy from 'lodash/orderBy';
import helper from '@/shared/helper';

Math.easeInOutQuad = (t, b, c, d) => {
	let time = t;
	time /= d / 2;
	if (time < 1) {
		return (((c / 2) * time) * time) + b;
	}
	time -= 1;
	return ((-c / 2) * ((time * (time - 2)) - 1)) + b;
};

function scrollTo(element, duration, fit) {
	const to = document.getElementsByClassName(element)[0].offsetTop - 70;
	const start = window.scrollY;
	const change = fit ? to - start : to - start;
	let currentTime = 0;
	const increment = 20;

	const animateScroll = () => {
		currentTime += increment;
		const val = Math.easeInOutQuad(currentTime, start, change, duration);
		window.scrollTo(0, val);
		if (currentTime < duration) {
			setTimeout(animateScroll, increment);
		}
	};
	animateScroll();
	this.isVisible = false;
}

function data() {
	return {
		modalConfirmation: {
			selectedRow: {},
			value: false,
		},
		languages: {
			es: {
				id: 'Es',
				name: 'Español',
				isSelected: false,
			},
			en: {
				id: 'En',
				name: 'English',
				isSelected: false,
			},
		},
		snackbar: {
			text: '',
			isVisible: false,
			color: '#05579b',
		},
		params: {
			page: 1,
			perPage: 30,
			search: null,
		},
		table: {
			lastPage: 0,
			rows: [],
		},
		scrolling: 0,
	};
}

function cancelModalConfirmation() {
	this.modalConfirmation.value = false;
}

function goTo(name, options) {
	this.$router.push({ name, ...options });
}

function getImageUrl(imageUrl) {
	return `${this.$imageUrl}/${imageUrl}`;
}

async function loadData(url, version = 2) {
	const query = {
		params: this.params,
	};
	if (version === 2) {
		query.headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
	}
	const { data: records, headers } = await this.$http.get(url, query);
	this.table.lastPage = Number(headers['x-last-page']);
	this.table.rows = records.data;
	return { records, headers };
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.loadData(url);
}

function openModalConfirmation(row) {
	this.modalConfirmation.selectedRow = row;
	this.modalConfirmation.value = true;
}

function showError(text = 'Oops, ocurrió un error.') {
	this.$bus.$emit('showSnackBar', { text, color: '#FF5253' });
}

function showNotification(text, color = '#4DC68C') {
	this.$bus.$emit('showSnackBar', { text, color });
}

function onToggleSnackBar() {
	this.$bus.$on('showSnackBar', (snackbar) => {
		const newSnackbar = Object.assign({}, snackbar);
		newSnackbar.isVisible = true;
		this.snackbar = newSnackbar;
		setTimeout(() => {
			this.snackbar.isVisible = false;
		}, 5000);
	});
}

function showParentView(name) {
	return this.$route.name.indexOf(name) > -1;
}

function showRow(columns, columnId) {
	const column = columns.find(h => h.id === columnId);
	return column.visible;
}

function selectIsRow(array, flag = 'isSelected', row, checked, config) {
	const arrayNew = array.map((rowData) => {
		const newRowData = { ...rowData };
		if (config) {
			if (newRowData[config]) {
				newRowData[flag] = checked;
			} else {
				newRowData[flag] = false;
			}
		} else if (row) {
			if (rowData.id === row.id) {
				newRowData[flag] = row[flag];
			}
		} else {
			newRowData[flag] = checked;
		}
		return newRowData;
	});
	return arrayNew;
}

function every(array, flag = 'isSelected', disabled) {
	const newArray = Object.assign([], array);
	let returnEvery;
	if (disabled) {
		returnEvery = newArray.every(element => !element[flag]);
	} else {
		returnEvery = newArray.every(element => element[flag]);
	}
	return returnEvery;
}

function editable() {
	return helper.getLocalData('flag-admin');
}

function onModal(value) {
	const body = document.getElementsByClassName('open-modal');
	const style = 'overflow: hidden';
	body[0].style = value ? style : '';
}

function sluggedName(name) {
	const options = {
		lower: true,
		remove: /[*+~,.()¿?'"!:@%]/g,
	};

	return slugify(name, options);
}

function fetchProducts() {
	const PRODUCTS_API = `app/${process.env.APP_CODE}/products`;
	this.$http.get(PRODUCTS_API).then((response) => {
		const products = response.data.data;
		this.$store.commit('SET_PRODUCTS', orderBy(products, 'title'));
	});
}

async function fetchCompany() {
	try {
			const { COMPANY_CODE, APP_CODE } = process.env;
			const COMPANY_API = `company/${COMPANY_CODE}/app/${APP_CODE}`;
			const response = await this.$http.get(COMPANY_API);
			const company = response.data.data;
			this.$store.commit('SET_COMPANY', company);
	} catch (error) {
			this.showError();
	}
}

const mixin = {
	data,
	computed: {
		editable,
	},
	methods: {
		cancelModalConfirmation,
		getImageUrl,
		goTo,
		loadData,
		onModal,
		onSearch,
		onToggleSnackBar,
		openModalConfirmation,
		showError,
		showNotification,
		showParentView,
		showRow,
		selectIsRow,
		every,
		scrollTo,
		sluggedName,
		fetchProducts,
		fetchCompany,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js